/**
 * @fileoverview 日志打印
 */
/**
 * 参考hls.js的console printer，并兼容hls.js
 * 统一各处使用的console输出，通过统一开关控制并输出相同的格式
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var LogCacheLimit = 4000;
var noop = function () { };
var dummyConsole = {
    trace: noop,
    debug: noop,
    info: noop,
    log: noop,
    warn: noop,
    error: noop,
};
var PatchedConsole = Object.assign({}, dummyConsole);
function patchConsole(functions) {
    (functions || Object.keys(dummyConsole)).forEach(function (key) {
        var _a;
        PatchedConsole[key] = ((_a = self.console) === null || _a === void 0 ? void 0 : _a[key]) || noop;
    });
}
/** 启用全局console的开关函数 */
export function enableConsoleOutput(levels) {
    patchConsole(levels);
    try {
        PatchedConsole.log();
    }
    catch (e) {
        PatchedConsole = dummyConsole;
    }
}
/**
 * @deprecated 为了兼容某些插件用引入thumbplayer-core的日志函数保留空函数
 */
export default function (scopeName) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
}
/**
 * 日志存储的模式, bitmap标识，可以多种模式组合
 */
export var LogMode;
(function (LogMode) {
    /** 在控制台中输出 */
    LogMode[LogMode["console"] = 1] = "console";
    /** 存入缓存中 */
    LogMode[LogMode["cache"] = 2] = "cache";
})(LogMode || (LogMode = {}));
/**
 * 绑定播放器实例的日志工具，将日志字符串cache起来使用
 */
var Logger = /** @class */ (function () {
    function Logger(playerId, scopeName, logModeConfig) {
        this.playerId = playerId;
        this.scopeName = scopeName;
        if (!this.playerId) {
            throw new Error('Missing logger id');
        }
        if (!Logger.cache[playerId]) {
            Logger.cache[playerId] = [];
        }
        // 默认仅使用log, warn, error的日志
        this.logModeConfig = __assign({ trace: LogMode.console, debug: LogMode.console, info: LogMode.console, log: LogMode.cache | LogMode.console, warn: LogMode.cache | LogMode.console, error: LogMode.cache | LogMode.console }, logModeConfig);
    }
    // 日志写入接口
    Logger.prototype.trace = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['trace'], args, false));
    };
    ;
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['debug'], args, false));
    };
    ;
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['info'], args, false));
    };
    ;
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['log'], args, false));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['warn'], args, false));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['error'], args, false));
    };
    Logger.prototype.callApi = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this, playerId = _a.playerId, scopeName = _a.scopeName;
        var logPrefix = "[".concat(playerId.slice(-8), "][").concat(getLogTime(), "]").concat(scopeName ? "[".concat(scopeName, "]") : '');
        // 日志打不打印出来都缓存起来，提供给外部分析日志
        if (this.logModeConfig[level] & LogMode.cache) {
            var payload = "[".concat(level, "]").concat(logPrefix, " ").concat(args.join(','));
            if (payload.length >= LogCacheLimit) {
                PatchedConsole.warn("Logger cache limit exceeded: ".concat(payload.length));
                payload = "".concat(payload.slice(0, LogCacheLimit), "...");
            }
            Logger.cache[playerId].push(payload);
        }
        // 注意，enableConsole的优先级会更高，如果全局关闭了某一种console输出，那么这里也不会输出
        if (this.logModeConfig[level] & LogMode.console) {
            PatchedConsole[level].apply(PatchedConsole, __spreadArray([logPrefix], args, false));
        }
    };
    /** @deprecated */
    Logger.level = 0;
    /** 缓存已经打印的日志字符串 */
    Logger.cache = {};
    return Logger;
}());
export { Logger };
/** 下载日志txt文本 */
export function dumpLog(data) {
    var element = document.createElement('a');
    var output = data.join('\n\n');
    element.setAttribute('href', "data:text/plain;charset=utf-8,".concat(encodeURIComponent(output)));
    element.setAttribute('download', "tp-log-".concat(Date.now(), ".txt"));
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
;
function getLogTime() {
    var time = new Date();
    var timeStr = "".concat(time.getHours(), ":").concat(time.getMinutes(), ":").concat(time.getSeconds())
        + ".".concat(("0000".concat(time.getMilliseconds())).slice(-3));
    return timeStr;
}
